"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
let SisTextBoxComponent = class SisTextBoxComponent {
    constructor() {
        this.dir = "ltr";
        this.isReadonly = false;
        this.valueChange = new core_1.EventEmitter();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.valueChange.emit(value);
    }
    get maxlength() {
        return this._maxlength;
    }
    set maxlength(val) {
        if (val) {
            this._maxlength = val;
        }
        else {
            this._maxlength = 200;
        }
    }
    ngOnInit() {
        if (this.type !== "number") {
            this.type = "text";
        }
    }
    getIsReadonly() {
        return this.isReadonly;
    }
    onKeyPress(evt) {
        if (this.value && this.maxlength && this.value.toString().length > this.maxlength) {
            evt.preventDefault();
        }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisTextBoxComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisTextBoxComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SisTextBoxComponent.prototype, "dir", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SisTextBoxComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], SisTextBoxComponent.prototype, "isReadonly", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], SisTextBoxComponent.prototype, "valueChange", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], SisTextBoxComponent.prototype, "value", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], SisTextBoxComponent.prototype, "maxlength", null);
SisTextBoxComponent = __decorate([
    core_1.Component({
        selector: "sis-simple-textbox",
        template: `
		<ng-container>
			<span [dir]="dir">
				<mat-form-field class="sis-form-field" color="accent" [floatLabel]="'never'">
					<input matInput [(ngModel)]="value" [id]="id"
						  [type]="type" [placeholder]="placeholder" [maxLength]="maxlength"
						  (keypress)="onKeyPress($event)">
				</mat-form-field>
			</span>
		</ng-container>
	`,
    })
], SisTextBoxComponent);
exports.SisTextBoxComponent = SisTextBoxComponent;
//# sourceMappingURL=sis-textbox.component.js.map